"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../atoms/Icon/Icon"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _SearchBar = require("./SearchBar.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SearchBar = function SearchBar(_ref) {
  var _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Type here' : _ref$placeholder,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-search-bar' : _ref$dataTestId,
      action = _ref.action;

  var handleAction = function handleAction(value) {
    if (typeof action === 'function') action(value);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_SearchBar.Occ_SearchBarForm, {
    size: size,
    "data-test-id": dataTestId,
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    }
  }, /*#__PURE__*/_react["default"].createElement(_SearchBar.Occ_SearchBarInput, {
    type: "search",
    placeholder: placeholder,
    onChange: function onChange(e) {
      return handleAction(e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "search",
    size: "xs"
  })));
};

var _default = SearchBar;
exports["default"] = _default;